export default "__VITE_ASSET__L_7$TnFx__"